import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import {tAnalysisService} from 'src/app/services/tAnalysis.service';
import { isNullOrUndefined } from 'util';
import { GLSettingService } from 'src/app/services/Accounting/GLSetting.service';
import { GLSettingModel } from 'src/app/models/Accounting/tGLSettingModel';
import { analysisModel} from 'src/app/models/Accounting/tAnalysisModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
@Component({
  selector: 'app-search-analysis-dialog',
  templateUrl: './search-analysis-dialog.component.html',
  styleUrls: ['./search-analysis-dialog.component.css']
})
export class SearchAnalysisDialogComponent implements OnInit {
  TAG = "SearchChartAccountDialogComponent";

  editForm: FormGroup;

  @Input() openCode: number;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  
  dataSource: MatTableDataSource<analysisModel>;
  checkLoadingDataSource: any;
  dataList: analysisModel[];
  GLdataList=[{value:1,displayName:"Analysis1"},{value:2,displayName:"Analysis2"}];
  displayedColumns: string[] = [
    'aysID',
    'aysType',
    'aysName',
    'aysNameFC',

  ];
  aysFilter = new FormControl();

  filteredValues = {
    aysID:'',aysType: '', aysName: '',aysNameFC:''
  };
  isLoading = true;

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private tAnalysisService:tAnalysisService,
    private router: Router,
    private glSettingService: GLSettingService,
  ) { }

  ngOnInit() {
    this.getGLSettingInfo();
    this.getAnalysisData();
  }

  getAnalysisData(){
    this.tAnalysisService.getGetDialog(this.openCode).subscribe(data =>{
      this.dataList=data;

      this.dataSource = new MatTableDataSource<analysisModel>(this.dataList);
      this.dataSource.paginator = this.paginator;

      //loading spinner
      this.isLoading = false;
      this.checkLoadingDataSource = data;
      //table sort
      this.dataSource.sort = this.sort;

      this.aysFilter.valueChanges.subscribe((value) => {
        this.filteredValues['aysID']=value;
        this.filteredValues['aysType'] = value;
        this.filteredValues['aysName'] = value;
        this.filteredValues['aysNameFC']=value;

        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.dataSource.filterPredicate = this.customFilterPredicate();
    });
  }
  getGLSettingInfo() {
    this.glSettingService.getAllDataByShopID(NavigationComponent.selectedShopID.toString()).subscribe((data: GLSettingModel[]) => {
      if (data.length > 0) {
        const resultModel: GLSettingModel = data[0];
        this.GLdataList=[{value:1,displayName:resultModel.namedAnalysis1},{value:2,displayName:resultModel.namedAnalysis2}]
        
      }
    });
  }
  getAysTypeName(Type:number){
    for(let i=0;i<this.GLdataList.length; i++){
      if(this.GLdataList[i].value === Type){
        return this.GLdataList[i].displayName;
      }
    }
  }

  customFilterPredicate() {
    const myFilterPredicate = (data: analysisModel, filter: string): boolean => {

      const searchString = JSON.parse(filter);

      return ((searchString.aysID.toLowerCase() === '' ||
      (data.aysID != null && data.aysID.toString().trim().toLowerCase().indexOf(searchString.aysID.toLowerCase()) !== -1))
      ||
      (searchString.aysType.toLowerCase() === '' ||
        (data.aysType != null && data.aysType.toString().trim().toLowerCase().indexOf(searchString.aysType.toLowerCase()) !== -1))
      ||
      (searchString.aysName.toLowerCase() === '' ||
        (data.aysName != null && data.aysName.toString().trim().toLowerCase().indexOf(searchString.aysName.toLowerCase()) !== -1))
      ||
      (searchString.aysNameFC.toLowerCase() === '' ||
        (data.aysNameFC != null && data.aysNameFC.toString().trim().toLowerCase().indexOf(searchString.aysNameFC.toLowerCase()) !== -1))   
    );
      
    };
    return myFilterPredicate;
  }

  selectedRecord(selectedModel: analysisModel) {
    this.log.i(this.TAG, "selectedRecord data = " + selectedModel.aysName);
    this.activeModal.close(selectedModel);

  }
}
